import { render, staticRenderFns } from "./OutsourcingMaintenanceRecord.vue?vue&type=template&id=7a4d3ffd&scoped=true"
import script from "./OutsourcingMaintenanceRecord.vue?vue&type=script&lang=js"
export * from "./OutsourcingMaintenanceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4d3ffd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4d3ffd')) {
      api.createRecord('7a4d3ffd', component.options)
    } else {
      api.reload('7a4d3ffd', component.options)
    }
    module.hot.accept("./OutsourcingMaintenanceRecord.vue?vue&type=template&id=7a4d3ffd&scoped=true", function () {
      api.rerender('7a4d3ffd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OutsourcingMaintenanceRecord/OutsourcingMaintenanceRecord.vue"
export default component.exports